"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var bonusImages = [
    '/img/getBonusPanel/bonus1.png',
    '/img/getBonusPanel/bonus2.png',
    '/img/getBonusPanel/bonus3.png',
];
var BonusImg = function () {
    var _a = (0, react_1.useState)(null), imageSrc = _a[0], setImageSrc = _a[1];
    (0, react_1.useEffect)(function () {
        var randomIndex = Math.floor(Math.random() * bonusImages.length);
        setImageSrc(bonusImages[randomIndex]);
    }, []);
    if (!imageSrc)
        return null;
    return (
    // eslint-disable-next-line
    react_1.default.createElement("img", { className: styles_module_scss_1.default.bonusImage, src: imageSrc, alt: "welcome bonus" }));
};
exports.default = BonusImg;
